// Vendor libraries
import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../directives/icon/icon.directive";
export class IconWrapperComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.name = this.eltRef.nativeElement.getAttribute('name');
    }
}
IconWrapperComponent.ɵfac = function IconWrapperComponent_Factory(t) { return new (t || IconWrapperComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
IconWrapperComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IconWrapperComponent, selectors: [["ycn-icon-wrapper"]], inputs: { name: "name" }, decls: 1, vars: 1, consts: [["ycnIcon", "", 3, "name"]], template: function IconWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(0, "svg", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("name", ctx.name);
    } }, dependencies: [i1.IconDirective], encapsulation: 2 });
